export default __webpack_public_path__ + "static/media/community-placeholder.a30076fe.svg";